import { memo, useEffect } from 'react';
import { Page } from '@bonanza-social/navigation';
import {
  Box,
  ScrollView,
  useBreakpointProp,
  useLayout,
} from '@bonanza-social/moonlight';
import { useResponsiveGridItemWidth } from '@bonanza-social/toolkit/hooks';
import { CashbackSection, PendingRewardsSection } from '../components';
import { useDispatch } from '@bonanza-social/toolkit/state';
import { fetchMetaGamesCount } from '@bonanza-social/meta-games';
import DailyGiftSection from '../components/DailyGiftSection/DailyGiftSection';

function RewardsPage() {
  const [containerLayout, onContainerLayout] = useLayout();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchMetaGamesCount());
  }, [dispatch]);

  const numberOfColumns = useBreakpointProp({
    mobile: 1,
    tablet: 2,
    desktop: 3,
  });

  const itemWidth = useResponsiveGridItemWidth({
    listWidth: containerLayout.width,
    numberOfColumns,
    gridGap: 'space-400',
    gridOffsetX: 'space-200',
  });

  return (
    <Page testID="rewards-page">
      <ScrollView
        contentContainerStyle={{
          width: '100%',
          maxWidth: 'max-page-width',
          marginHorizontal: 'auto',
        }}
      >
        <Box gap="space-600" padding="space-400" onLayout={onContainerLayout}>
          {/* TODO: Uncomment when we have free spins */}
          {/* <FreeSpinsSection /> */}
          <PendingRewardsSection itemWidth={itemWidth} />
          <DailyGiftSection />
          {/* BOGI: Check itemwidth */}
          <CashbackSection itemWidth={itemWidth} />
        </Box>
      </ScrollView>
    </Page>
  );
}

export default memo(RewardsPage);
